import { createContext, ReactNode, useContext, useMemo } from "react";

/**
 * True when the booking sheet is showing a closed / non-editable booking (opened via
 * `/client/booking/:jobId`). Panels read this to disable every input and hide the Proceed / Book /
 * Add affordances so the sheet becomes a faithful read-only replay of the finished trip (DEV-446).
 *
 * Deliberately its own flag rather than reusing ClientScopeContext.isViewOnly, which means something
 * different (the operator's managed client was removed).
 */
const BookingViewOnlyContext = createContext(false);

export const BookingViewOnlyProvider = ({ value, children }: { value: boolean; children: ReactNode }) => {
  // Constant value, but memo keeps the provider identity stable across the sheet's re-renders.
  const viewOnly = useMemo(() => value, [value]);
  return <BookingViewOnlyContext.Provider value={viewOnly}>{children}</BookingViewOnlyContext.Provider>;
};

/** Whether the surrounding booking sheet is read-only. Defaults to false outside a provider. */
export const useBookingViewOnly = (): boolean => useContext(BookingViewOnlyContext);
